import {chargeSelectValeursTextes} from "./dom.js";
import {Événements} from "./constantes.js";

export class Pagination {

    static maxItemsParPage = 6500;
    static minItemsParPage = 50;

    nbTotalRésultats = 0;
    nbRésultats = 0;
    pageCourante = 0;
    nbTotalPages = 0;
    taillePage = 50;

    selectÉlément;

    constructor() {
        this.selectÉlément = document.getElementById("pagination-taillePage");
        if(this.selectÉlément) this.selectÉlément.addEventListener("change", (e) => this.changeTaille(e));
    }

    setTailleMax() {
        this.selectÉlément.options[this.selectÉlément.options.length - 1].selected = true;
        this.changeTaille();
    }

    setTailleMin() {
        this.selectÉlément.options[0].selected = true;
        this.changeTaille();
    }

    changeTaille(e) {

        this.taillePage = this.selectÉlément.value;

        let paginationChangeÉvénement = new CustomEvent(Événements.PAGINATION,
            {
                detail: {
                    pagination: this
                }
            });

        document.dispatchEvent(paginationChangeÉvénement);
    }

    ajusteAuxRésultats(résultat) {

        let limiteMax = résultat.résultatsInfo.nbTotalRésultats > résultat.résultatsInfo.nbTotalItems ? résultat.résultatsInfo.nbTotalItems : résultat.résultatsInfo.nbTotalRésultats;
        let limiteMin = Math.min(Pagination.minItemsParPage, limiteMax);

        let valeursTextes = this.getTaillesValeursTextes(limiteMin, résultat);

        this.taillePage = this.getValeurActive(valeursTextes);

        chargeSelectValeursTextes(this.selectÉlément, valeursTextes, this.taillePage);

    }

    getValeurActive(valeursTextes) {
        let valeurActive = valeursTextes[valeursTextes.length - 1].valeur;
        if (valeursTextes.length > 1) {
            const idx = valeursTextes.findIndex((valeurTexte) => valeurTexte.valeur >= this.taillePage);
            if (idx !== -1) {
                valeurActive = valeursTextes[idx].valeur;
            }
        }
        return valeurActive;
    }

    getTaillesValeursTextes(limiteMin, résultat) {

        let valeursTextes = [];

        let départ = Math.min(limiteMin, résultat.résultatsInfo.nbTotalRésultats);

        valeursTextes.push({
            valeur: départ,
            texte: départ
        });

        if (Pagination.minItemsParPage < résultat.résultatsInfo.nbTotalRésultats) {

            if ((départ + Pagination.minItemsParPage) >= résultat.résultatsInfo.nbTotalRésultats) {
                valeursTextes.push({
                    valeur: résultat.résultatsInfo.nbTotalRésultats,
                    texte: résultat.résultatsInfo.nbTotalRésultats
                });

            } else {
                let v = Pagination.minItemsParPage * 2;
                while (v <= résultat.résultatsInfo.nbTotalItems) {
                    valeursTextes.push({
                        valeur: v,
                        texte: v
                    });
                    v = v + Pagination.minItemsParPage;
                }

                let limiteAtteinte = résultat.résultatsInfo.nbTotalItems < résultat.résultatsInfo.nbTotalRésultats;
                if (limiteAtteinte) {
                    let dernièreEntrée = valeursTextes[valeursTextes.length - 1];
                    dernièreEntrée.texte += " (limite)";
                } else {
                    // Afficher les derniers...
                    if (v > résultat.résultatsInfo.nbTotalItems) {
                        valeursTextes.push({
                            valeur: résultat.résultatsInfo.nbTotalItems,
                            texte: résultat.résultatsInfo.nbTotalItems
                        });
                    }
                }


            }

        }

        return valeursTextes;
    }
}
